<template>
  <div>
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div class="content-wrapper d-flex align-items-center auth">
          <div class="row flex-grow">
            <div class="col-lg-4 mx-auto">
              <div class="auth-form-light text-center p-5">

                <h1>SWAPKREDO</h1>

                <div class="brand-logo justify-content-center">
                  <img src="/assets/img/admin.png" />
                </div>

                <h2>Admin Login</h2>

                <!-- Google Button -->
                <div class="mt-4">
                  <div id="googleLogin"></div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",

  data() {
    return {
      message: {},
    };
  },

  created() {
    this.getIp();
    this.getTime();
    localStorage.clear();
  },

  mounted() {
    const token = localStorage.getItem("token");

    if (token) {
      this.$router.push({ name: "kmtc" });
    } else {
      this.waitForGoogleScript();
    }
  },

  methods: {
    async getIp() {
      try {
        const res = await this.axios.get("https://api.ipify.org/?format=json");
        this.message.ip_address = res.data.ip;
      } catch (e) {
        console.error("IP fetch error:", e);
      }
    },

    getTime() {
      this.message.date_time = new Date().toISOString();
    },

    // 🔥 Wait until Google script is loaded
    waitForGoogleScript() {
      const interval = setInterval(() => {
        if (window.google && window.google.accounts) {
          clearInterval(interval);
          this.initGoogleLogin();
        }
      }, 300);
    },

    // ✅ Initialize Google Login
    initGoogleLogin() {
      try {
        google.accounts.id.initialize({
          client_id: "926781068556-e3smgo4071f7bsp6lopkutik396rvgsc.apps.googleusercontent.com",
          callback: this.handleCredentialResponse,
          auto_select: false,
        });

        google.accounts.id.renderButton(
          document.getElementById("googleLogin"),
          {
            theme: "outline",
            size: "large",
            width: 300,
          }
        );

        // Optional One Tap
        google.accounts.id.prompt();

      } catch (e) {
        console.error("Google init error:", e);
      }
    },

    // ✅ Handle Google Response
    async handleCredentialResponse(response) {
      console.log("Google response:", response);

      if (!response.credential) {
        console.error("No credential received");
        return;
      }

      try {
        const res = await this.axios.post("/api/auth/google-login", {
          token: response.credential,
        });

        if (res.data.status) {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("user", JSON.stringify(res.data.user));

          console.log("Login success → redirecting");

          this.$router.push({ name: "kmtc" });

        } else {
          this.$swal({
            title: "Authentication Failed",
            text: res.data.message,
            icon: "warning",
          });
        }

      } catch (err) {
        console.error("Backend error:", err);

        this.$toast.open({
          message: "Google login failed!",
          type: "error",
          position: "top",
        });
      }
    },
  },
};
</script>